function readChatWidgetUrl(value) {
  try {
    return typeof value === 'string' ? value.trim() : '';
  } catch (error) {
    return '';
  }
}

function useOwnChatWidget(value) {
  return readChatWidgetUrl(value) !== '';
}

function salesmartlyScriptUrl(widgetUrl, salesmartlyKey) {
  if (useOwnChatWidget(widgetUrl)) return null;
  if (!salesmartlyKey) return null;
  return `https://assets.salesmartly.com/js/${salesmartlyKey}.js`;
}

function parseChatWidgetTarget(value) {
  const trimmed = readChatWidgetUrl(value);
  if (!trimmed) return null;
  try {
    const url = new URL(trimmed);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    return { href: url.href, origin: url.origin };
  } catch (error) {
    return null;
  }
}

module.exports = {
  readChatWidgetUrl,
  useOwnChatWidget,
  salesmartlyScriptUrl,
  parseChatWidgetTarget,
};
